"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M20.5 8.84c0-2.67-1.116-5.09-2.916-6.84l-1.44 1.398c1.435 1.394 2.32 3.317 2.32 5.442 0 4.251-3.546 7.697-7.922 7.697a8.013 8.013 0 01-5.603-2.254L3.5 15.681a10.06 10.06 0 006.343 2.81v1.532h-4.07V22h10.175v-1.977h-4.07v-1.595c4.868-.634 8.622-4.685 8.622-9.588z" }),
    React.createElement("path", { d: "M4.755 8.656c0-3.003 2.506-5.437 5.597-5.437 3.09 0 5.596 2.434 5.596 5.437 0 3.002-2.506 5.436-5.596 5.436-3.091 0-5.597-2.434-5.597-5.436z" })), "Localization");
//# sourceMappingURL=Localization.js.map